module.exports = __webpack_public_path__ + "img/categorie-quisommesnous-famille-boutrais-small.a8e39435.jpg";